
import React, { useEffect, useState, useRef } from "react";
import { createWarehouse, deleteWarehouse, fetchAllWarehouse, updateWarehouse } from "../../../resources/WarehouseResource"
import DataTable from 'react-data-table-component';
import { baseUrl } from "../../../constants/Constant";
import { showSuccessToast } from "../../../utils/GlobalToast";
import { format } from "date-fns";
import { getLocalAuth } from "../../../utils/AuthUtils";
import ErrorNotFound from "../../errors/Error";

function Warehouse() {
  const values = getLocalAuth()
  const privilege = JSON.parse(values.authPrivilege);

  let dataPrivilege = privilege.data.menu.filter(data => {
    return data.code === "Warehouse"
  });

  let dataRead = dataPrivilege.length === 0 ? [] : dataPrivilege[0].action_page.filter(data => {
    return data.code === "Read"
  });

  let dataCreate = dataPrivilege.length === 0 ? [] : dataPrivilege[0].action_page.filter(data => {
    return data.code === "Create"
  });

  let dataUpdate = dataPrivilege.length === 0 ? [] : dataPrivilege[0].action_page.filter(data => {
    return data.code === "Update"
  });

  let dataDelete = dataPrivilege.length === 0 ? [] : dataPrivilege[0].action_page.filter(data => {
    return data.code === "Delete"
  });

  const [dataWarehouse, setDataWarehouse] = useState([]);
  const [name, setName] = useState("");
  const [address, setAddress] = useState("");
  const [idEdit, setIdEdit] = useState(null);
  const [nameEdit, setNameEdit] = useState("");
  const [addressEdit, setAddressEdit] = useState("");

  const [isError, setIsError] = useState(false);
  const [error, setError] = useState("");
  const [isErrorDelete, setIsErrorDelete] = useState(false);
  const [errorDelete, setErrorDelete] = useState("");
  const [isErrorEdit, setIsErrorEdit] = useState(false);
  const [errorEdit, setErrorEdit] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const [selectedImage, setSelectedImage] = useState(null);
  const ref = useRef(null);
  const refEdit = useRef(null);
  const [defaultImage, setDefaultImage] = useState(null);

  const [showAddModal, setShowAddModal] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [showEditModal, setShowEditModal] = useState(false);

  const fetchWarehouse = () => {
    fetchAllWarehouse()
      .then((res) => {
        setDataWarehouse(res.data);
      })
      .catch((err) => {
        setDataWarehouse([]);
      });
  };

  useEffect(() => {
    fetchWarehouse();
  }, []);

  const handleSubmit = (e) => {
    e.preventDefault();
    postWarehouse(name, address, selectedImage);
  }

  const postWarehouse = async (name, address, selectedImage) => {


    setIsLoading(true);
    await createWarehouse(name, address, selectedImage).then((res) => {
      setIsLoading(false);
      setIsError(false);
      showSuccessToast("Success Added Warehouse!");
      setShowAddModal(false);
      setName("");
      setAddress("");
      if (ref.current) {
        ref.current.value = "";
        ref.current.type = "text";
        ref.current.type = "file";
      }
      setSelectedImage(null);
      fetchWarehouse();
    }).catch((err) => {
      setIsLoading(false);
      setError(typeof err === 'undefined' ? 'There was an error checking your connection or input' : err);
      setIsError(true);
    });


  }

  const handleData = (data) => {
    setIdEdit(data.id);
    setNameEdit(data.name);
    setAddressEdit(data.address);
    setDefaultImage(data.image)
  }

  const handleDelete = () => {
    setIsLoading(true);
    deleteWarehouse(idEdit).then((res) => {
      setIsLoading(false);
      setIsErrorDelete(false);
      showSuccessToast("Success Deleted Warehouse!");
      setShowDeleteModal(false);
      fetchWarehouse();
    }).catch((err) => {
      setIsLoading(false);
      setErrorDelete(err);
      setIsErrorDelete(true);
    });
  }

  const handleEdit = (e) => {
    e.preventDefault();
    setIsLoading(true);
    if (selectedImage === null) {
      fetch(`${baseUrl}/${defaultImage}`)
        .then((res) => res.blob())
        .then(async (myBlob) => {
          const myFile = new File([myBlob], 'image.jpeg', { type: myBlob.type });
          await updateWarehouse(idEdit, nameEdit, addressEdit, myFile).then((res) => {
            setIsLoading(false);
            setIsErrorEdit(false);
            showSuccessToast("Success Updated Warehouse!");
            setShowEditModal(false);
            if (refEdit.current) {
              refEdit.current.value = "";
              refEdit.current.type = "text";
              refEdit.current.type = "file";
            }
            setSelectedImage(null);
            fetchWarehouse();
          }).catch((err) => {
            setIsLoading(false);
            setErrorEdit(err);
            setIsErrorEdit(true);
          });
        }).catch(async (err) => {
          await updateWarehouse(idEdit, nameEdit, addressEdit).then((res) => {
            setIsLoading(false);
            setIsErrorEdit(false);
            showSuccessToast("Success Updated Warehouse!");
            setShowEditModal(false);
            if (refEdit.current) {
              refEdit.current.value = "";
              refEdit.current.type = "text";
              refEdit.current.type = "file";
            }
            setSelectedImage(null);
            fetchWarehouse();
          }).catch((err) => {
            setIsLoading(false);
            setErrorEdit(err);
            setIsErrorEdit(true);
          });
        });
    } else {
      updateWarehouse(idEdit, nameEdit, addressEdit, selectedImage).then((res) => {
        setIsLoading(false);
        setIsErrorEdit(false);
        showSuccessToast("Success Updated Warehouse!");
        setShowEditModal(false);
        if (refEdit.current) {
          refEdit.current.value = "";
          refEdit.current.type = "text";
          refEdit.current.type = "file";
        }
        setSelectedImage(null);
        fetchWarehouse();
      }).catch((err) => {
        setIsLoading(false);
        setErrorEdit(err);
        setIsErrorEdit(true);
      });
    }
  }

  const handleImgLoadingError = (e) => {
    // default image add, if associated image is not available...
    e.target.src = '../assets/images/default-image.png';
  };

  const columns = [
    {
      name: 'No',
      cell: (row, index) => index + 1,
      width: '60px'
    },
    {
      name: 'Background',
      selector: row => (<div className="product-img bg-transparent border">
        <img src={`${baseUrl}/${row.image}`} width="35" height="35" alt="" onError={handleImgLoadingError} />
      </div>),
      sortable: true,
      width: '180px'
    },
    {
      name: 'Name',
      selector: row => row.name,
      sortable: true,
    },
    {
      name: 'Address',
      selector: row => row.address,
      sortable: true,
    },
    {
      name: 'Created At',
      selector: row => row.created_at === null ? '-' : format(row.created_at, "yyyy-MM-dd HH:mm").toString(),
      sortable: true,
    },
    {
      name: 'Updated At',
      selector: row => row.updated_at === null ? '-' : format(row.updated_at, "yyyy-MM-dd HH:mm").toString(),
      sortable: true,
    },
    {
      name: 'Actions',
      cell: row => (
        <>
          {dataDelete.length === 0 ? <div></div> : !dataDelete[0].is_active ? <div></div> : <button type="button" style={{ marginRight: "8px" }} className="btn btn-danger" onClick={() => {
            handleData(row);
            setShowDeleteModal(true);
          }}>Delete</button>}
          <div className={`modal fade ${showDeleteModal ? 'show' : ''}`} style={{ display: showDeleteModal ? 'block' : 'none', backgroundColor: 'rgba(0, 0, 0, 0.1)' }}>
            <div className="modal-dialog">
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title">Delete this data?</h5>
                  <button type="button" className="btn-close" onClick={() => setShowDeleteModal(false)} aria-label="Close"></button>
                </div>
                {isErrorDelete ? <div style={{ paddingLeft: '16px', paddingRight: '16px', paddingTop: '16px', paddingBottom: '0px' }}>
                  <div className="alert alert-danger alert-dismissible fade show" role="alert">{errorDelete}
                    <button type="button" className="btn-close" data-bs-dismiss="alert" aria-label="Close" onClick={() => setIsErrorDelete(false)}></button>
                  </div>
                </div> : null}
                <div className="modal-body">
                  {`You will delete ${nameEdit}`}
                </div>
                <div className="modal-footer">
                  <button type="button" className="btn btn-secondary" onClick={() => setShowDeleteModal(false)}>Cancel</button>
                  {!isLoading ? <button type="submit" className="btn btn-danger" onClick={() => handleDelete()}>Delete</button> :
                    <button className="btn btn-danger" type="button" disabled> <span style={{ marginRight: '4px' }} className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                      Loading...</button>}
                </div>
              </div>
            </div>
          </div>
          {dataUpdate.length === 0 ? <div></div> : !dataUpdate[0].is_active ? <div></div> : <button type="button" className="btn btn-info" onClick={() => {
            handleData(row);
            setShowEditModal(true);
          }}>View</button>}
          <div className={`modal fade ${showEditModal ? 'show' : ''}`} style={{ display: showEditModal ? 'block' : 'none', backgroundColor: 'rgba(0, 0, 0, 0.1)' }}>
            <div className="modal-dialog modal-dialog-scrollable">
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title">Master Data Warehouse</h5>
                  <button type="button" className="btn-close" onClick={() => setShowEditModal(false)} aria-label="Close"></button>
                </div>
                {isErrorEdit ? <div style={{ paddingLeft: '16px', paddingRight: '16px', paddingTop: '16px', paddingBottom: '0px' }}>
                  <div className="alert alert-danger alert-dismissible fade show" role="alert">{errorEdit}
                    <button type="button" className="btn-close" data-bs-dismiss="alert" aria-label="Close" onClick={() => setIsErrorEdit(false)}></button>
                  </div>
                </div> : null}
                <div className="modal-body">
                  <form onSubmit={handleEdit}>
                    <div className="mb-3">
                      <label className="form-label fw-bold">Name</label>
                      <input required type="text" value={nameEdit} onChange={(e) => setNameEdit(e.target.value)} className="form-control" />
                    </div>
                    <div className="mb-3">
                      <label className="form-label fw-bold">Address</label>
                      <input required type="text" value={addressEdit} onChange={(e) => setAddressEdit(e.target.value)} className="form-control" />
                    </div>
                    <div className="mb-3">
                      <label className="form-label fw-bold">Background Image</label>
                      <div className="row">
                        <div className="col-auto">
                          <div className="product-img bg-transparent border">
                            <img src={selectedImage === null ? `${baseUrl}/${defaultImage}` : URL.createObjectURL(selectedImage)} width="35" height="35" alt="" onError={handleImgLoadingError} />
                          </div>
                        </div>
                        <div className="col">
                          <input className="form-control" type="file" id="formFile" accept="image/png, image/jpeg" onChange={(e) =>
                            setSelectedImage(e.target.files[0])
                          } ref={refEdit} />
                        </div>
                      </div>
                    </div>
                    <div className="modal-footer">
                      <button type="button" className="btn btn-secondary" onClick={() => setShowEditModal(false)}>Cancel</button>
                      {!isLoading ? <button type="submit" className="btn btn-info">Save</button> :
                        <button className="btn btn-info" type="button" disabled> <span style={{ marginRight: '4px' }} className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                          Loading...</button>}
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </>
      ),
    },
  ];

  return (
    <div>
      {dataRead.length === 0 ? <ErrorNotFound /> : !dataRead[0].is_active ? <ErrorNotFound /> :
        <div className="page-content-wrapper">
          <div className="page-content">
            <div className="card">
              <div className="card-body">
                <div className="card-title">
                  <div className="row">
                    <div className="col-md-10">
                      <h4 className="mb-0">Master Data Warehouse</h4>
                    </div>
                    <div className="col-md-2 text-end d-grid">
                      {dataCreate.length === 0 ? <div></div> : !dataCreate[0].is_active ? <div></div> : <button type="button" className="btn btn-info ms-auto radius-10" onClick={() => {
                        setShowAddModal(true);
                      }}><i className='bx bx-plus'></i> Warehouse</button>}
                    </div>
                    <div className={`modal fade ${showAddModal ? 'show' : ''}`} style={{ display: showAddModal ? 'block' : 'none', backgroundColor: 'rgba(0, 0, 0, 0.5)' }}>
                      <div className="modal-dialog modal-dialog-scrollable">
                        <div className="modal-content">
                          <div className="modal-header">
                            <h5 className="modal-title">Master Data Warehouse</h5>
                            <button type="button" className="btn-close" onClick={() => {
                              setShowAddModal(false);
                            }} aria-label="Close"></button>
                          </div>
                          {isError ? <div style={{ paddingLeft: '16px', paddingRight: '16px', paddingTop: '16px', paddingBottom: '0px' }}>
                            <div className="alert alert-danger alert-dismissible fade show" role="alert">{error}
                              <button type="button" className="btn-close" data-bs-dismiss="alert" aria-label="Close" onClick={() => setIsError(false)}></button>
                            </div>
                          </div> : null}
                          <div className="modal-body">
                            <form onSubmit={handleSubmit}>
                              <div className="mb-3">
                                <label className="form-label fw-bold">Name</label>
                                <input required type="text" className="form-control" value={name} onChange={(e) => setName(e.target.value)} />
                              </div>
                              <div className="mb-3">
                                <label className="form-label fw-bold">Location</label>
                                <input required type="text" className="form-control" value={address} onChange={(e) => setAddress(e.target.value)} />
                              </div>
                              <div className="mb-3">
                                <label className="form-label fw-bold">Background Image</label>
                                <input required className="form-control" type="file" id="formFile" accept="image/png, image/jpeg" onChange={(e) =>
                                  setSelectedImage(e.target.files[0])
                                } ref={ref} />
                              </div>
                              <br></br>
                              <div className="modal-footer">
                                <button type="button" className="btn btn-secondary" onClick={() => {
                                  setShowAddModal(false);
                                }}>Cancel</button>
                                {!isLoading ? <button type="submit" className="btn btn-info">Submit</button> :
                                  <button className="btn btn-info" type="button" disabled> <span style={{ marginRight: '4px' }} className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                                    Loading...</button>}
                              </div>
                            </form>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <hr />
                <div className="table-responsive">
                  <DataTable
                    columns={columns}
                    data={dataWarehouse}
                    pagination
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      }
    </div>
  );
}

export default Warehouse